require('./ProgramDetails.scss');

const b = require('app/www/libs/b')('program-details');

const _ = {
    filter: require('lodash/filter'),
    flatten: require('lodash/flatten'),
};

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Global = require('app/www/components/blocks/Global/Global');
const Link = require('app/www/components/blocks/Link/Link');

const roles = require('app/common/constants/roles');
const DIRECTOR = roles[0];
const PRODUCER = roles[4];
const ACTOR = roles[3];

class ProgramDetails extends React.PureComponent {

    render() {
        const {
            i18n,
            type,
            year,
            genres,
            isShow,
            duration,
            countries,
            personsMap,
        } = this.props;

        let programRoles = roles;

        if (genres) {
            programRoles = roles.filter(role => role !== ACTOR);
        }

        const isSerial = isShow || type.isSerial;

        const details = _.filter(
            _.flatten([
                programRoles.map(role => {
                    let personsByRole = (personsMap[role] || []);

                    const attrs = {};

                    const linkProps = {
                        attrs: {
                            target: '_blank',
                        },
                    };

                    if ([DIRECTOR, PRODUCER, ACTOR].includes(role)) {
                        attrs.itemProp = role;

                        linkProps.attrs = Object.assign({
                            itemProp: role,
                            itemType: 'http://schema.org/Person',
                            itemScope: true,
                        }, linkProps.attrs);
                    }

                    personsByRole = personsByRole.map((person, index) => ([
                        person.id ? (
                            <Link
                                key={person.id}
                                className={b('link')}
                                url={Global.kinopoiskProgramPersonUrl(person.id)}
                                {...linkProps}
                            >
                                <i itemProp="name">{person.name}</i>
                            </Link>
                        ) : (
                            <span key={person} {...attrs}>{person}</span>
                        ),
                        index !== personsByRole.length - 1 && ', ',
                    ]));

                    return {
                        label: `${i18n.get(`program-details.${role}`, personsByRole.length)}`,
                        content: personsByRole,
                    };
                }),
                genres && {
                    label: i18n.get('program-details.genre'),
                    content: genres.join(', '),
                    attrs: {
                        itemProp: 'genre',
                    },
                },
                {
                    label: i18n.get('program-details.country-and-year'),
                    content: _.flatten([countries, year]).filter(Boolean).join(', '),
                },
                duration && {
                    label: i18n.get(`program-details.duration-${isSerial ? 'episode' : 'program'}`),
                    content: `
                        ${isSerial ? '≈' : ''}
                        ${i18n.get('program-details.duration', duration, {number: duration})}
                    `,
                },
            ]),
            'content.length'
        );

        return details.length > 0 && (
            <div className={b()}>
                {details.map(detail => (
                    <div key={detail.label} className={b('item')}>
                        <h3 className={b('label')}>
                            {detail.label}
                        </h3>
                        <div className={b('text')} {...detail.attrs}>
                            {detail.content}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

ProgramDetails.propTypes = {
    type: PropTypes.object,
    year: PropTypes.number,
    genres: PropTypes.arrayOf(PropTypes.string),
    duration: PropTypes.number,
    countries: PropTypes.arrayOf(PropTypes.string),
    personsMap: PropTypes.object,
};

module.exports = withI18n(ProgramDetails);
